import { Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { LocalizationService } from '@abp/ng.core';

@Component({
  selector: 'app-metro-confirmation',
  templateUrl: './metro-confirmation.component.html',
  standalone: false
})
export class MetroConfirmationComponent implements OnInit{
  @Input() title = '';
  @Input() message = '';
  @Input() confirmText = 'Confirm';
  @Input() cancelText = '';
  @Input() type: 'danger' | 'warning' | 'info' | 'success' = 'danger';

  @Output() confirmed = new EventEmitter<boolean>();

  localizedTitle='';
  localizedMsg='';

  closeIcon = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"  stroke="currentColor" >
              <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
            </svg>
              `;

  private readonly l = inject(LocalizationService);

  private translateOrFallback(value: string): string {
    const result = this.l.instant(value);
    return result !== value ? result : value;
  }

  ngOnInit(): void {
    this.localizedTitle = this.translateOrFallback(this.title);
    this.localizedMsg = this.translateOrFallback(this.message);
    this.confirmText = this.translateOrFallback(this.confirmText);
    this.cancelText = this.translateOrFallback(this.cancelText);
  }

}
